import React from 'react';
import { MobileAppContent } from 'src/components/MobileAppCallToAction/MobileAppCallToAction';
import './mobile-app-cta-card.scss';

interface IMobileAppCtaCardProps {
  header: string;
  description: string;
}

const MobileAppCtaCard = ({ header, description }: IMobileAppCtaCardProps) => (
  <div className="mobile-app-cta-card">
    <MobileAppContent
      header={header}
      description={description}
      className="modal-context"
    />
  </div>
);

export default MobileAppCtaCard;